<template>
  <div class="submit-success">
    <h4 class="center title">{{ $t('registration_success') }}</h4>
    <p class="center desc">{{ $t('Register.successTips1') }}</p>
    <p class="center bottom-text desc">{{ email }}</p>
    <div class="activationCodeContent">
      <el-input v-model="input1" placeholder="" ref="activationCodeInput1" maxlength="1" @paste.native="handlePaste"
        @keydown.native="handleKeyDown1" @input="activationCodeInput1" class="activationCode center-input"></el-input>
      <el-input v-model="input2" placeholder="" ref="activationCodeInput2" maxlength="1" @paste.native="handlePaste"
        @keydown.native="handleKeyDown2" @input="activationCodeInput2" class="activationCode center-input"></el-input>
      <el-input v-model="input3" placeholder="" ref="activationCodeInput3" maxlength="1" @paste.native="handlePaste"
        @keydown.native="handleKeyDown3" @input="activationCodeInput3" class="activationCode center-input"></el-input>
      <el-input v-model="input4" placeholder="" ref="activationCodeInput4" maxlength="1" @paste.native="handlePaste"
        @keydown.native="handleKeyDown4" @input="activationCodeInput4" class="activationCode center-input"></el-input>
      <el-input v-model="input5" placeholder="" ref="activationCodeInput5" maxlength="1" @paste.native="handlePaste"
        @keydown.native="handleKeyDown5" @input="activationCodeInput5" class="activationCode center-input"></el-input>
      <el-input v-model="input6" placeholder="" ref="activationCodeInput6" maxlength="1" @paste.native="handlePaste"
        @keydown.native="handleKeyDown6" @input="activationCodeInput6" class="activationCode center-input"></el-input>
    </div>
    <vs-button class="w-full mt-6" color="primary" type="filled" @click="activateImmediate">{{ $t('activateImmediately')
    }}</vs-button>
    <p class="center bot-desc">
      <span>{{ $t('Activation_email_received') }}?</span>
      <span @click="resetSend" class="theme-color pointer">{{ $t('Register.successTips4') }}</span>
    </p>
  </div>
</template>

<script>
import { getEmailAddress } from '@/utils/common';
import { mapGetters } from 'vuex'
import { retryRegActiveEmail, activeUseCode } from '@/api/user.js'
import { numbersAndLetters } from '@/utils/validate'
export default {
  name: "submitSuccess",
  computed: {
    ...mapGetters(['userInfo']),
    email() {
      return this.userInfo.email;
    },
  },
  data() {
    return {
      input1: "",
      input2: "",
      input3: "",
      input4: "",
      input5: "",
      input6: "",
      previnput1: "",
      previnput2: "",
      previnput3: "",
      previnput4: "",
      previnput5: "",
      previnput6: "",
      pastedText: "",
      activateLoading: false,
      resetSendLoading: false,
    }
  },
  methods: {
    getEmailAddress,
    isItAutomaticallyActivated() {
      let activeCode = "" + this.input1 + this.input2 + this.input3 + this.input4 + this.input5 + this.input6;
      if (activeCode.length == 6) {
        this.activateImmediate();
      }
    },
    activateImmediate() {
      if (this.activateLoading) return;
      let activeCode = "" + this.input1 + this.input2 + this.input3 + this.input4 + this.input5 + this.input6;
      if (activeCode.length < 6) {
        this.$message({
          message: this.$t('pleaseEnterTheCompleteActivationCode'),
          type: 'warning'
        })
        return;
      }
      let activeData = {
        activeCode: activeCode
      }
      this.activateLoading = true;
      this.$vs.loading();
      activeUseCode(activeData).then((res) => {
        localStorage.setItem('token', res.data.token);
        localStorage.setItem('userInfo', JSON.stringify(res.data.cust));
        this.$store.commit('setUserInfo', res.data.cust);
        this.$message({
          message: this.$t('Activation_successful'),
          type: 'success'
        });
        setTimeout(() => {
          this.$vs.loading.close();
          this.$router.push({ name: 'perfectInfo' }).catch(() => {
            window.location.href = this.$router.resolve({ name: 'perfectInfo' }).href;
          });
        }, 500);
      }).catch((error) => {
        setTimeout(() => {
          this.$vs.loading.close();
        }, 200)
      }).finally(() => {
        this.activateLoading = false;
      });
    },
    handlePaste(event) {
      // 获取剪贴板数据（兼容写法）
      const clipboardData = event.clipboardData || window.clipboardData
      // 获取纯文本内容
      this.pastedText = clipboardData.getData('text')
      this.pastedText = numbersAndLetters(this.pastedText)
      let _self = this;
      if (this.pastedText.length != 0) {
        this.pastedText = this.pastedText.split("");


        for (let i = 0; i < this.pastedText.length; i++) {
          if (i == 0) {
            setTimeout(() => {
              _self.input1 = _self.pastedText[i];
              _self.$refs.activationCodeInput1.focus()
            }, 200)

          }
          if (i == 1) {
            setTimeout(() => {
              _self.input2 = _self.pastedText[i];
              _self.$refs.activationCodeInput2.focus()
            }, 400)

          }
          if (i == 2) {
            setTimeout(() => {
              _self.input3 = _self.pastedText[i];
              _self.$refs.activationCodeInput3.focus()
            }, 600)

          }
          if (i == 3) {
            setTimeout(() => {
              _self.input4 = _self.pastedText[i];
              _self.$refs.activationCodeInput4.focus()
            }, 800)

          }
          if (i == 4) {
            setTimeout(() => {
              _self.input5 = _self.pastedText[i];
              _self.$refs.activationCodeInput5.focus()
            }, 1000)

          }
          if (i == 5) {
            setTimeout(() => {
              _self.input6 = _self.pastedText[i];
              _self.$refs.activationCodeInput6.focus()
            }, 1200)

          }
        }
      }
      setTimeout(() => {
        this.isItAutomaticallyActivated();
      }, 1200)
    },
    handleKeyDown1(event) {
      // 监听 Backspace 键（keyCode 为 8）
      if (event.key === 'Backspace' || event.keyCode === 8) {
        if (this.input1 != "") {
          this.input1 = "";
          this.previnput1 = "";
        }
      }
    },
    handleKeyDown2(event) {
      // 监听 Backspace 键（keyCode 为 8）
      if (event.key === 'Backspace' || event.keyCode === 8) {
        if (this.input2 == "") {
          setTimeout(() => {
            this.$refs.activationCodeInput1.focus()
          })
        } else {
          this.input2 = "";
          this.previnput2 = "";
        }
      }
    },
    handleKeyDown3(event) {
      // 监听 Backspace 键（keyCode 为 8）
      if (event.key === 'Backspace' || event.keyCode === 8) {
        if (this.input3 == "") {
          setTimeout(() => {
            this.$refs.activationCodeInput2.focus()
          })
        } else {
          this.input3 = "";
          this.previnput3 = "";
        }
      }
    },
    handleKeyDown4(event) {
      // 监听 Backspace 键（keyCode 为 8）
      if (event.key === 'Backspace' || event.keyCode === 8) {
        if (this.input4 == "") {
          setTimeout(() => {
            this.$refs.activationCodeInput3.focus()
          })
        } else {
          this.input4 = "";
          this.previnput4 = "";
        }
      }
    },
    handleKeyDown5(event) {
      // 监听 Backspace 键（keyCode 为 8）
      if (event.key === 'Backspace' || event.keyCode === 8) {
        if (this.input5 == "") {
          setTimeout(() => {
            this.$refs.activationCodeInput4.focus()
          })
        } else {
          this.input5 = "";
          this.previnput5 = "";
        }
      }
    },
    handleKeyDown6(event) {
      // 监听 Backspace 键（keyCode 为 8）
      if (event.key === 'Backspace' || event.keyCode === 8) {
        if (this.input6 == "") {
          setTimeout(() => {
            this.$refs.activationCodeInput5.focus()
          })
        } else {
          this.input6 = "";
          this.previnput6 = "";
        }
      }
    },
    jumpeEmailLink() {
      let herf = this.getEmailAddress(this.userInfo.email);
      window.open(herf, '_blank');
    },
    activationCodeInput1(value) {
      this.input1 = numbersAndLetters(value);
      if (this.input1.length > 1) {
        this.input1 = this.input1.split("")[this.input1.split("").length - 1];
      }
      if (this.input1.length == 0) {
        //this.input1 = this.previnput1;
      }
      //this.previnput1 = this.input1;
      if (this.input1.length == 1) {
        this.$refs.activationCodeInput2.focus()
      }
      this.isItAutomaticallyActivated();
    },
    activationCodeInput2(value) {
      this.input2 = numbersAndLetters(value);
      if (this.input2.length > 1) {
        this.input2 = this.input2.split("")[this.input2.split("").length - 1];
      }
      if (this.input2.length == 0) {
        //this.input2 = this.previnput2;
      }
      //this.previnput2 = this.input2;
      if (this.input2.length == 1) {
        this.$refs.activationCodeInput3.focus()
      }
      this.isItAutomaticallyActivated();
    },
    activationCodeInput3(value) {
      this.input3 = numbersAndLetters(value);
      if (this.input3.length > 1) {
        this.input3 = this.input3.split("")[this.input3.split("").length - 1];
      }
      if (this.input3.length == 0) {
        //this.input3 = this.previnput3;
      }
      //this.previnput3 = this.input3;
      if (this.input3.length == 1) {
        this.$refs.activationCodeInput4.focus()
      }
      this.isItAutomaticallyActivated();
    },
    activationCodeInput4(value) {
      this.input4 = numbersAndLetters(value);
      if (this.input4.length > 1) {
        this.input4 = this.input4.split("")[this.input4.split("").length - 1];
      }
      if (this.input4.length == 0) {
        //this.input4 = this.previnput4;
      }
      //this.previnput4 = this.input4;
      if (this.input4.length == 1) {
        this.$refs.activationCodeInput5.focus()
      }
      this.isItAutomaticallyActivated();
    },
    activationCodeInput5(value) {
      this.input5 = numbersAndLetters(value);
      if (this.input5.length > 1) {
        this.input5 = this.input5.split("")[this.input5.split("").length - 1];
      }
      if (this.input5.length == 0) {
        //this.input5 = this.previnput5;
      }
      //this.previnput5 = this.input5;
      if (this.input5.length == 1) {
        this.$refs.activationCodeInput6.focus()
      }
      this.isItAutomaticallyActivated();
    },
    activationCodeInput6(value) {
      this.input6 = numbersAndLetters(value);
      if (this.input6.length > 1) {
        this.input6 = this.input6.split("")[this.input6.split("").length - 1];
      }
      if (this.input6.length == 0) {
        //this.input6 = this.previnput6;
      }
      this.isItAutomaticallyActivated();
      //this.previnput6 = this.input6;
    },
    resetSend() {
      if (this.resetSendLoading) return;
      let parmas = {
        custId: this.userInfo.id
      };
      this.resetSendLoading = true;
      retryRegActiveEmail(parmas).then((result) => {
        this.$message({
          message: this.$t('The_activation_email_has_been_sent_successfully_Please_go_to_the_email_to_confirm_the_activation_as_soon_as_possible_Thank_you'),
          type: 'success'
        })
      }).finally(() => {
        this.resetSendLoading = false;
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.submit-success {
  .desc {
    font-size: 14px;
  }

  .title {
    margin-bottom: 20px;
    font-weight: bold;
  }

  .bottom-text {
    //margin-bottom: 20px;
  }

  .bot-desc {
    margin-top: 20px;
  }

  .activationCodeContent {
    width: 320px;
    display: flex;
    margin: 20px auto;
  }


  .activationCode {
    width: 40px;
    flex: auto;
    padding: 5px;
  }

  /deep/ .center-input .el-input__inner {
    text-align: center;
    font-weight: bold;
    color: #000;
    font-size: 20px;
    padding: 0 0px !important;
  }


  // 移动端
  @media screen and (max-width: 768px) {
    .activationCodeContent {
      width: auto;
      display: flex;
      margin: 20px auto;
    }

    .activationCode {
      width: auto;
      flex: auto;
      padding: 5px;
    }

    /deep/ .center-input .el-input__inner {
      text-align: center;
      font-weight: normal;
      color: #000;
      font-size: 16px;
    }
  }
}
</style>
